module.exports={
  "labmanager": [
    "Academic Professor",
    "Academic Student",
    "Architect",
    "Chemist",
    "Construction",
    "Corporate Management",
    "Engineer",
    "Facility Manager / Supervisor/ Director",
    "Hospital Administrator",
    "Investigator",
    "Lab Manager / Supervisor / Director",
    "Lab Planner",
    "Medical Practitioner",
    "Project Manager / Supervisor/ Director",
    "Purchasing Agent",
    "QA / QC Manager / Supervisor / Director",
    "R&D Manager / Supervisor / Director",
    "Research Scientist",
    "Safety Risk Manager",
    "Technical Consultant",
    "Technician",
    "Other"
  ],
  "clinicallab": [
    "Academic Professor",
    "Compliance Officer",
    "Corporate Management",
    "Facility Manager/Supervisor/Director",
    "Information Technology",
    "Lab Manager/Supervisor/Director",
    "Medical/Clinical Specialist",
    "Medical Laboratory Scientist/Technician",
    "Nurse",
    "Pathologist",
    "Pharmacist",
    "Phlebotomist",
    "Psychiatrist",
    "Physician",
    "Purchasing Agent",
    "Research Associate",
    "Surgical",
    "Technical Consultant",
    "Other"
  ],
  "drugdiscoverynews": [
    "Academic Department Head/Chair",
    "Analyst",
    "Business Development/Finance/Legal",
    "Clinical Researcher/Professional",
    "Consultant",
    "Executive Mgmt (CEO/Pres/VP)",
    "Group or Section Leader/Project Mgr.",
    "Lab Director/Lab Mgr./Dept. Mgr.",
    "Lab Manager",
    "Lab/Research Manager",
    "Other",
    "Physician/Medical Professional",
    "Postdoctoral Fellow",
    "Principle Investigator",
    "Production/Process Engineer",
    "Professor/Assistant/ Associate Professor ",
    "Program Manager",
    "Purchasing Agent/Manager",
    "Regulatory/QA/Drug Safety Officer",
    "Research Director/VP Research/CSO",
    "Research Scientist",
    "Retired",
    "Senior Researcher",
    "Statistician",
    "Technician/Research Assistance",
    "Undergraduate Student"
  ]
}
